// extracted by mini-css-extract-plugin
export default {"display-lease-container":"display-lease-container-5361","whitespace":"whitespace-6a47"};